import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

import { UserModel } from 'utils/types';


export interface GetAuthList {
  AuthSearchModel: {
    AuthNo: string,
    AuthStatus: string,
    CompanyId?: string | null,
    DOB?: string | null,
    FirstName: string,
    LastName: string,
    MembId?: string,
    ProvKeyId?: string | null,
    Provider: Object,
    ProviderName: string,
    Status: string | null,
    index?: number,
    statusIndex?: number,
  },
  UserIdModel: UserModel
}

export interface GetAuthListResponse {
  RPRmiRevFullName: string
  RmiAuthNo: string
  RmiCompanyId: string
  RmiCreatedDate: string
  RmiExprDate: string
  RmiMembId: string
  RmiMembName: string
  RmiReqProvKeyId: string
  RmiStatus: string
}


export const getAuthList = (userModel: GetAuthList) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_AUTH_LIST_REQUEST });

  return api.authorization.list.get(userModel)
    .then((res: any) => {

      dispatch({
        type: types.GET_AUTH_LIST_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, err.message, 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_AUTH_LIST_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getAuthListGroups = (userModel: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_AUTH_LIST_GROUP_REQUEST });

  return api.authorization.list.getGroups(userModel)
    .then((res: any) => {

      dispatch({
        type: types.GET_AUTH_LIST_GROUP_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_AUTH_LIST_GROUP_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
